import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// ---- Indicateur global d'activité réseau ----
let pending = 0;
const listeners = new Set();
const notify = () => listeners.forEach((l) => l(pending));
export function subscribeBusy(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("erp_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  pending++;
  notify();
  return config;
});

api.interceptors.response.use(
  (res) => {
    pending = Math.max(0, pending - 1);
    notify();
    return res;
  },
  (error) => {
    pending = Math.max(0, pending - 1);
    notify();
    if (!error.config?.silent) {
      const status = error.response?.status;
      const detail = error.response?.data?.detail || error.message || "Une erreur est survenue";
      // 401/403 gérés par le flux d'auth — pas de toast transitoire
      if (status !== 401 && status !== 403) {
        toast.error(typeof detail === "string" ? detail : "Une erreur est survenue");
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatEur(n) {
  if (n == null) return "—";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
}

export function formatEur2(n) {
  if (n == null) return "—";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
}

export function formatHours(h) {
  // Arrondit à 0.25 près et affiche en format français lisible.
  if (h == null || isNaN(h)) return "—";
  const rounded = Math.round(h * 4) / 4;
  const intPart = Math.floor(rounded);
  const dec = rounded - intPart;
  let str;
  if (dec === 0) str = `${intPart}`;
  else if (dec === 0.25) str = `${intPart},25`;
  else if (dec === 0.5) str = `${intPart},5`;
  else if (dec === 0.75) str = `${intPart},75`;
  else str = rounded.toString().replace(".", ",");
  return `${str} h`;
}

export function formatDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return s; }
}
